import React, { Component } from 'react'
import RaisedButton from 'material-ui/RaisedButton';
import RefreshIcon from 'material-ui/svg-icons/navigation/refresh';
import { List, ListItem } from 'material-ui/List';
import Checkbox from 'material-ui/Checkbox';
import { Toolbar, ToolbarGroup, ToolbarTitle } from 'material-ui/Toolbar';
import FlatButton from 'material-ui/FlatButton';
import moment from 'moment';

import * as DataAPI from "../../../common/DataAPI.js";
import Dialogs from "../../../common/Dialogs.js";

class Other extends Component {
  constructor() {
    super();
    this.state = {
      isSmsEnabled: false,
    };

    this.resetTickets = this.resetTickets.bind(this);
    this.updateSmsEnabled = this.updateSmsEnabled.bind(this);
  }

  componentWillMount() {
    this.getSmsEnabled();
  }

  getSmsEnabled() {
    DataAPI.get('/api/adminPanel/smsEnabled', {}, (err, isSmsEnabled) => {
      if (err) return console.error('getSmsEnabled error:', JSON.stringify(err));

      this.setState({
        isSmsEnabled,
      });
    });
  }

  updateSmsEnabled(event, isInputChecked) {
    DataAPI.post('/api/adminPanel/smsEnabled', {
      smsEnabled: isInputChecked,
    }, (err) => {
      if (err) return console.error('updateSmsEnabled error:', JSON.stringify(err));

      this.setState({
        isSmsEnabled: isInputChecked,
      });
    });
  }

  resetTickets() {
    this.dialogs.confirm({
      title: '確認重置叫號？',
    }, () => {
      DataAPI.put('/api/keypad/resetTickets', null, (err) => {
        if (err) return this.dialogs.error(err);
      });
    });
  };

  render() {
    return (
      <div>
        <List>
          {
            this.state.isSmsEnabled &&
            <ListItem
              leftCheckbox={<Checkbox
                checked={this.state.isSmsEnabled}
                onCheck={this.updateSmsEnabled}
              />}
              primaryText="SMS通知"
              secondaryText="打勾啟用"
            />
          }
          {/*<ListItem*/}
          {/*primaryText="重置"*/}
          {/*secondaryText="按此將會重置單號，並存入報告"*/}
          {/*onClick={this.resetTicket}*/}
          {/*/>*/}
        </List>
        <br/>
        <RaisedButton
          label="重置叫號"
          primary={true}
          onClick={this.resetTickets}
          icon={<RefreshIcon className="icon" />}
        />
        <Dialogs onInit={dialog => (this.dialogs = dialog)} />
      </div>
    )
  }
}

export default Other;


// WEBPACK FOOTER //
// client/adminPanel/panel/others/Other.js